import React from "react"
import { OverlayTrigger, Tooltip } from "react-bootstrap"

export default function ProductReviewIcon({ reasons = [], id }) {
  if (!reasons.length) return null

  const text = reasons.join(" ")

  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id={`product-review-${id}`}>{text}</Tooltip>}>
      <span className="d-inline-block ml-2" role="img" aria-label={text}>
        <i className="bi bi-exclamation-triangle-fill text-warning" />
      </span>
    </OverlayTrigger>
  )
}
